import type { VehicleInfo } from '../types';
import type { DealerLocationData } from '../hooks/useGetDealerDetails';

export const createMetaDescription = (
  vehicleData: VehicleInfo | undefined,
  dealerInfo: DealerLocationData | undefined,
) => {
  const vehicleType = vehicleData?.vehicleType;
  const vehicleNumber =
    vehicleType === 'non-audi' ? vehicleData?.stockNumber : vehicleData?.audiCode;
  const isNew = vehicleType === 'new';

  const type = isNew ? 'Research the' : 'Pre-owned';

  const usedDetails = `for sale in ${dealerInfo?.city}, ${dealerInfo?.region}. View pictures, specs & pricing. Schedule a test drive to make sure it's the perfect fit for you.`;
  const newDetails = `in ${dealerInfo?.city}, ${dealerInfo?.region}. View pictures, specs, features and pricing, and schedule your test drive at ${vehicleData?.dealerName} today.`;

  const typeSpecificDetails = isNew ? newDetails : usedDetails;

  const description =
    vehicleData && dealerInfo
      ? `${type} ${vehicleData.modelName} ${typeSpecificDetails} ${vehicleNumber}`
      : '';

  return description;
};
